<template>
    <b-row style="position:fixed;top:0;bottom:0;right:0;left:0;overflow:auto;" md="12">
        <b-col v-if="!hideCarousel" md="5" class="carousel-side d-flex justify-content-center align-items-center hidden-md-down" style="background-color:#4129A8;">
                <carousel></carousel>
        </b-col>
        <b-col :md="hideCarousel ? 12 : 7" style="background-color:#fff;" class="form-side d-flex">
            <b-card 
            :img-src="showLogo ? logoImg : ''"
            img-alt="Image"
            img-top
            style="width:25%;min-width:30rem;margin:auto;border:none;color:#022B49;"
            >
                <b-row class="m-3" style="font-weight: bold; margin-bottom:3px; font-size: 1.75em;">
                    <b-col>
                        <span style="text-align: center;">{{$t('resetPassword')}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mb-3">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <img src="../assets/icon/password_icon.svg"/>
                            </b-input-group-prepend>
                            <div class="placeholder-wrap">
                                <b-form-input v-model="user.password" type="password" id="password"
                                :class="['input-field', {'is-invalid': passwordError }]" 
                                required/>
                                <span class="placeholder">
                                    {{$t('passwordPlaceholder')}} <span class="password-info">({{$t('passwordInfo')}})</span>
                                </span>
                            </div>
                            <b-input-group-append is-text>
                                <span v-if="showPassword" @click="switchPasswordVisibility('password')" key="password-visible">
                                    <!--<i class="fas fa-eye" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                    <img src="../assets/icon/showPassword_icon.svg" key="showConfirmPass"><img>
                                </span>
                                <span v-else @click="switchPasswordVisibility('password')" key="password-invisible">
                                    <!--<i class="fas fa-eye-slash" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                    <img src="../assets/icon/hidePassword_icon.svg" key="hideConfirmPass"><img>
                                </span>
                            </b-input-group-append>
                        </b-input-group>
                        <span v-show="passwordError" class="validation-error">{{$t(passwordErrorType)}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mb-3">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <img src="../assets/icon/password_icon.svg"/>
                            </b-input-group-prepend>
                            <b-form-input v-model="user.passwordConfirmation" :placeholder="$t('confirmPasswordPlaceholder')" type="password" id="passwordConfirmation"
                             :class="['input-field', {'is-invalid': passwordError }]" required/>
                            <b-input-group-append is-text>
                                <span v-if="showPasswordConfirmation" @click="switchPasswordVisibility('passwordConfirmation')" key="password-confirmation-visible">
                                    <!--<i class="fas fa-eye" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                    <img src="../assets/icon/showPassword_icon.svg" key="showConfirmPass"><img>
                                </span>
                                <span v-else @click="switchPasswordVisibility('passwordConfirmation')" key="password-confirmation-invisible">
                                    <!--<i class="fas fa-eye-slash" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                    <img src="../assets/icon/hidePassword_icon.svg" key="hideConfirmPass"><img>
                                </span>
                            </b-input-group-append>
                        </b-input-group>
                        <span v-show="passwordError && passwordErrorType == 'passwordsDoNotMatch'" class="validation-error">{{$t(passwordErrorType)}}</span>
                    </b-col>
                </b-row>
                <b-row> 
                    <b-col class="mt-3">
                        <b-button @click="resetPassword()" class="w-50 light-green" >{{ $t('resetPasswordButton') }}</b-button>
                    </b-col>
                </b-row>
                
            </b-card>
        </b-col>

    </b-row>

</template>

<script>
import Carousel from '../components/Carousel.vue';
import _ from 'lodash';
export default {
    components: { Carousel },
    name: 'ResetPassword',
    data() {
        return {
            user:{
                id:null,
                email:null,
                uuid:null,
                password:null,
                passwordConfirmation:null
            },
            passwordError: false,
            passwordErrorType: null,
            showPassword: false,
            showPasswordConfirmation: false,
            uuid : null,
            err: null,
            title: 'Carbon Intelligence',
            logoImg: '../../static/background.jpg',
            showLogo: false,
            hideCarousel: false
        };
    },
    methods: {
        isValid(){
            this.passwordError = !this.user.password;
            this.passwordErrorType = this.passwordError ? 'passwordEmptyValidationError' : null;
            if(!this.passwordError) {
                this.passwordError = this.user.password.length < 7;
                this.passwordErrorType = 'passwordLengthError';
            }
            if(!this.passwordError) {
                this.passwordError = !this.isPasswordValid(this.user.password);
                this.passwordErrorType = 'passwordNotValidError';
            }
            if(!this.passwordError) {
                this.passwordError = !this.isPasswordsMatch(this.user.password, this.user.passwordConfirmation);
                this.passwordErrorType = 'passwordsDoNotMatch';
            }

            return !this.passwordError;
        },
        isPasswordValid(password){
            if(password){
                return this.user.password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/);
            } 
        },
        isPasswordsMatch(password, passwordConfirmation){
            return _.isEqual(password, passwordConfirmation);
        },
        switchPasswordVisibility(id){
            id == 'password' ? this.showPassword=!this.showPassword : this.showPasswordConfirmation=!this.showPasswordConfirmation;
            const passwordField = document.querySelector('#'+id);
            if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text')
            else passwordField.setAttribute('type', 'password')
        },
        resetPassword() {
            if(this.isValid()){
                this.$Progress.start();
                return this.axios
                    .post('/resetPassword', {user: this.user})
                    .then(() => {
                        this.$router.push({path: '/login', query:{passwordResetInfo:false}});
                        this.$Progress.finish();
                        return true;
                    })
                    .catch(err => {
                        this.err = err;
                        this.$Progress.finish();
                    });
            }
        },
        init(){
            return this.axios.get(`/resetPassword/${this.uuid}`).then(({data}) => {
                this.user.id = data.id;
                this.user.email = data.email;
                this.user.uuid = data.uuid;
                this.isLoaded = true;
            }).catch(err => {
                this.err = err;
                this.$router.push({path: '/login'});
                    this.$message({
                            type: 'error',
                            message: this.$t('invalidLink')
                        });
            });
        },
        onResize(){
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created(){
        this.uuid = this.route.query.uuid;
        this.onResize();
        this.init();
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.logoImg = '../../static/garanti.png';
            this.title = 'titleGaranti';
            this.showLogo = true;
            this.hideCarousel = true;
        }
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.onResize);
    }
};
</script>

<style lang="scss" scoped>
.carousel-side, .form-side {
    height: 100vh;
    width: 100%;
}
.input-field {
    background-color: #EFEDF5;
    color: #022B49;
    font-size: 1em;
}
.input-field::placeholder {
    color : #A0A0A0;
}
.input-field:focus {
    outline: none !important;
    border:1px solid #8276c3;
    box-shadow: none;
}

.validation-error {
    color: #F14079;
    float: left;
    font-size: .7em;
}

a {
    color: #D118A8;
    text-decoration: underline;
    font-weight: bold;
}

.alert-info-cl{
    color: #407994; 
    background-color:rbga(241,64,121,0.2) !important;
}
.alert-danger-cl{
    color: #F14079; 
    background-color:rbga(241,64,121,0.2) !important;
}

.input-group-prepend .input-group-text {
  background-color: #EFEDF5;
}
.input-group-append .input-group-text {
  background-color: #EFEDF5;
}

.input-group-prepend > .form-input   {
  border-left:0 !important;
}
.placeholder-wrap {
    display: inline-block;
    position: relative;
    background: #EFEDF5;
    overflow: hidden;
    flex: 1 1 auto;
    width: 1%;
}
.placeholder-wrap .placeholder {
    position: absolute;
    top: 50%;
    left: 15px;
    color: #A0A0A0;
    margin-top: -.5em;
    line-height: 1em;
    z-index: 9;
    overflow: hidden;
    white-space: nowrap;
}
.placeholder-wrap input {
    background-color: transparent;
    border-radius: 0;
    position: relative;
    z-index: 10;
}

.placeholder-wrap input:focus + .placeholder,
.placeholder-wrap input[required]:valid + .placeholder,
.placeholder-wrap input.not-empty + .placeholder {
    display: none;
}

.placeholder span {
  color: #A0A0A0;
  font-size: .7em;
}
@media only screen and (max-width:780px) {
    .carousel-side, .form-side {
        height: 100vh;
        width: 100%
    }
    .placeholder span {
        color: #A0A0A0;
        font-size: .6em;
    }
}


.light-green {
    background-color: #49DC9B;
    font-weight: bold;
    border: none;
}
.captcha-input {
    position: relative;
    width: 180px;
    padding: 5px;
    font-size: 16px;
    margin: auto;
}


</style>

<i18n>
    {
        "tr": {
            "title":"Reengen Sürdürülebilirlik Platformu",
            "titleGaranti":"Çevre Yönetim Sistemi Yazılımı (ÇYS)",
            "alert": "Email adresi bulunamadı",
            "invalidLink": "Bu link artık geçersiz.",
            "resetPassword": "Şifre Yenileme",
            "passwordPlaceholder": "Şifre",
            "passwordInfo": "7+ karakter ve bir rakam",
            "confirmPasswordPlaceholder": "Şifre Tekrar",
            "resetPasswordButton": "Şifreyi Yenile",
            "passwordEmptyValidationError": "Lütfen bir şifre girin",
            "passwordLengthError": "Şifreniz en az 7 karakter içermeli",
            "passwordNotValidError": "Şifreniz en az 1 harf ve 1 sayı içermeli",
            "passwordsDoNotMatch": "Şfireler uyuşmuyor",
            "canNotLeaveEmpty": "Bu alan boş bırakılamaz"
        },
        "en": {
            "title":"Reengen Sustainability Platform",
            "titleGaranti":"Environmental Management System Software (EMS)",
            "alert": "Email address not found",
            "invalidLink": "This url no longer valid",
            "resetPassword": "Reset Password",
            "passwordPlaceholder": "Password",
            "passwordInfo": "7+ characters and one number",
            "confirmPasswordPlaceholder": "Confirm Password",
            "resetPasswordButton": "Reset Password",
            "passwordEmptyValidationError": "Please enter a password",
            "passwordLengthError": "Your password must contain at least 7 characters",
            "passwordNotValidError": "Your password must contain at least 1 letter and 1 number",
            "passwordsDoNotMatch": "Passwords do not match",
            "canNotLeaveEmpty": "This field can not be empty"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue